export default {
  computed: {},
  data: function data() {
    return {};
  }
};